module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robb Turner, Jessica Carbone, Tina Rupp\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Robb Turner is owner of Madava Farms in the Hudson River Valley, home to Crown Maple Syrup."), _c('BR'), _c('BR'), _vm._v(" Jessica Carbone is a native New Englander and culinary writer, editor, and historian based in Washington, DC.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16dYRyy/tc-custom/9781613122327.jpg?1729082793592",
      "alt": "This image is the cover for the book Crown Maple Guide to Maple Syrup"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crown Maple Guide to Maple Syrup\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Sixty-five sweet and savory recipes, plus tons of tips, trivia, and photos!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This is the ultimate guide to maple syrup, with sixty-five recipes, instructions on tapping and evaporating, and an overview of the fascinating history of maple syrup in the United States. Not just a cookbook, it offers a comprehensive look into the world of maple syrup, complete with archival images and tutorials on the process."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With recipes for maple-pecan sticky buns, maple-glazed duck, maple lemon bars, and much more, this beautifully illustrated guide comes from the producers of Crown Maple, a leading organic maple syrup—carried by gourmet food markets and used in many of the world’s best kitchens, including NoMad, Eleven Madison Park, Bouchon, Lincoln, and more.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ABRAMS\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0